import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LightingGlyph = /*#__PURE__*/createElement("g", {
  id: "lighting"
}, /*#__PURE__*/createElement("path", {
  d: "M48.1,65.3c0,1.9-2.7,3.4-6,3.4s-6-1.5-6-3.4H48.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M48.8,56.6H35.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h13.6c0.8,0,1.5,0.7,1.5,1.5S49.6,56.6,48.8,56.6z"
}), /*#__PURE__*/createElement("path", {
  d: "M48.8,60.4H35.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h13.6c0.8,0,1.5,0.7,1.5,1.5S49.6,60.4,48.8,60.4z"
}), /*#__PURE__*/createElement("path", {
  d: "M48.8,64.3H35.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h13.6c0.8,0,1.5,0.7,1.5,1.5S49.6,64.3,48.8,64.3z"
}), /*#__PURE__*/createElement("path", {
  d: "M47.9,52.8H36.7l-0.4-0.5C35,50.8,24.6,38,24.9,31.6c0.4-8.6,7.5-15.8,16-16.4c4.8-0.3,9.3,1.3,12.8,4.6 c3.5,3.2,5.4,7.8,5.4,12.6c0,5.8-9.7,18.3-10.8,19.7L47.9,52.8z M38.1,49.8h8.4c3.1-4,9.7-13.4,9.7-17.3c0-4-1.6-7.7-4.5-10.4 c-2.9-2.7-6.6-4-10.6-3.8c-7.1,0.4-12.9,6.4-13.2,13.5C27.7,35.6,33.8,44.6,38.1,49.8z"
}));
const Lighting = createSvg({
  name: 'lighting',
  path: LightingGlyph
});

export default Lighting;
export { LightingGlyph };
